export const forumCategories = [
    { id: "nouveautes", name: "Nouveautés" },
    { id: "box_office", name: "Box-Office" },
    { id: "gala", name: "Gala & Cérémonies" },
    { id: "stars", name: "Acteurs étoiles" },
    { id: "autre", name: "Autre" },
    // Ajoute plus de catégories spécifiques ici
  ];
  